import {
  View,
  Text,
  SafeAreaView,
  ScrollView,
  Image,
  TouchableOpacity,
  Dimensions,
  ImageBackground,
  Animated
} from "react-native";
import React, { useState, useEffect } from "react";
import { interests } from "./data";
import GlobalStyles from "../../globalStyles/globalStyles";
import { styles } from "./interestsStyles/interestsStyles";
import { useNavigation } from "@react-navigation/native";
// import Icons from "../../assets/Icons";
import { fetchUserDataFromStorage } from "../../utils/localStorage";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { authToken } from "../../utils/config";
import Brand from "../../assets/Icons/BrandIcons";
import FeedIcons from "../../assets/Icons/FeedIcons";
import { RootState, useSelector } from "../../redux/store";
import { BlurView } from "expo-blur";
import { Colors } from "../../globalStyles/ColorConfig";
import CustomComponent from "../../components/CustomComponent";
import InterestScreenIcons from "../../assets/Icons/InterestIcons";
import CoachMarkScreen from "./CoachMarkScreen/CoachMarkScreen";

interface UserData {
  user: {
    _id: string;
    firstName: string;
  };
  experience: {};
  message: string;
}
interface CurrentUser {
  _id: string;
  photos: string[];
}

export default function Interests() {
  const navigation = useNavigation();
  const [interesetHeight, setInteresetHeight] = useState(328);
  const [userData, setUserData] = useState<UserData[]>([]);
  const [uniqueUserIds, setUniqueUserIds] = useState(new Set());
  const [currentUser, setCurrentUser] = useState<CurrentUser | null>(null);

  const [showCoachMark, setShowCoachMark] = useState(false);
  const [coachMarkVisited, setCoachMarkVisited] = useState(false);
  const [opacity] = useState(new Animated.Value(0));

  const { userToken } = useSelector((state: RootState) => state.user);
  const fetchData = async () => {
    try {
      const apiUrl = "https://api-dev.spark.hushl.in/user/people-interested";

      const response = await fetch(apiUrl, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${userToken}`,
        },
      });

      if (!response.ok) {
        // console.log("Error fetching data:", response.status);
      }

      const responseData = await response.json();
      // console.log("people Interested", responseData.data.peopleInterested);

      setUserData(responseData.data.peopleInterested);
      const uniqueIdsSet = new Set(
        responseData.data.peopleInterested.map(
          (interest: any) => interest.user._id
        )
      );
      setUniqueUserIds(uniqueIdsSet);
    } catch (error) {
      console.error("Error fetching data:", (error as Error).message);
    }
  };

  const logUserDataFromStorage = async () => {
    try {
      const storedUserData = await AsyncStorage.getItem("userData");
      if (storedUserData) {
        const parsedUserData = JSON.parse(storedUserData);
        setCurrentUser(parsedUserData);
      } else {
        // console.log("No user data found in local storage.");
      }
    } catch (error) {
      console.error("Error retrieving user data from local storage:", error);
    }
  };
  // useEffect(() => {
  //   fetchData();
  //   logUserDataFromStorage();
  // }, []);

  useEffect(() => {
    const checkCoachMarkVisited = async () => {
      try {
        const visited = await AsyncStorage.getItem('interestCoachMarkVisited');
        if (visited !== null) {
          setCoachMarkVisited(true);
        }
      } catch (error) {
        console.error('Error retrieving coach mark visit status:', error);
      }
    };

    checkCoachMarkVisited();
  }, []);

  //responsible for the transition between the 2 screens
  useEffect(() => {
      let timer:any;
      if (!coachMarkVisited) {
        timer = setTimeout(() => {
        Animated.timing(opacity, {
          toValue: 1,
          duration: 1000,
          useNativeDriver: true,
        }).start();
          setShowCoachMark(true);
        }, 1000);
      }
      return () => clearTimeout(timer);
  }, [coachMarkVisited]);

  const handleGotIt = async () => {
    try {
      await AsyncStorage.setItem('interestCoachMarkVisited', 'true');
      setCoachMarkVisited(true);
      Animated.timing(opacity, {
        toValue: 0,
        duration: 1000,
        useNativeDriver: true,
      }).start(() => setShowCoachMark(false));
    } catch (error) {
      console.error('Error setting coach mark visit status:', error);
    }
  };


  const handleInterestPress = (interest: any) => {
    navigation?.navigate("OpenInterest", {
      interest: interest,
    });
  };



  return (
    <View style={{
      position:"relative",
      flex:1
    }}>
      
     {
      showCoachMark &&
          <Animated.View style={{ 
            flex: 1, 
            opacity:opacity,
            position:"absolute",
            width:"100%",
            height:"100%",
            zIndex:showCoachMark? 2:0
            }}>
            <CoachMarkScreen onGotIt={handleGotIt} />
          </Animated.View>
     }
     <View style={{
      position:"absolute",
      flex:1,
      width:"100%",
      height:"100%"
     }}>
     <ImageBackground
      source={require("../../assets/StaticImages/InterestImages/Interest_date1.png")}
        style={{
          flex: 1,
          backgroundColor: "#000",
          // marginTop: 15,
        }}
      >
        <ScrollView>
          <View style={styles.Container}>
            <Text
              style={[
                GlobalStyles.heading2,
                {
                  paddingHorizontal: 16,
                  color:"white"
                },
              ]}
            >
              Interested
            </Text>
            {uniqueUserIds.size === 0 ? (
              <>
                <View
                  style={{
                    flex: 1,
                    justifyContent: "center",
                    alignItems: "center",
                    marginTop: "57%",
                  }}
                >
                  <View
                    style={{
                      transform: [{ scale: 1.9 }],
                    }}
                  >
                    <InterestScreenIcons.CenterHeartIcon />
                  </View>
                  <Text
                    style={[
                      GlobalStyles.heading2,
                      { marginTop: 40, textAlign: "center",color:"white" },
                    ]}
                  >
                    Your Likes will {"\n"}
                    appear here
                  </Text>
                </View>
              </>
            ) : (
              <>
                <View>
                  {[...uniqueUserIds].map((userId, index) => {
                    const interest = userData.find(
                      (item) => item.user._id === userId
                    );

                    if (!interest) {
                      return null;
                    }

                    return (
                      <TouchableOpacity
                        onPress={() => {
                          handleInterestPress(interest);
                        }}
                        style={styles.InterestCard}
                        key={index}
                      >
                        <View style={styles.ProfileWrap}>
                          <View style={styles.InterestCardImgWrap}>
                            {interest?.experience ? (
                              <>
                                <Image
                                  source={{
                                    uri: currentUser?.photos[1],
                                  }}
                                  style={[
                                    styles.InterestCardImg,
                                    {
                                      height: interesetHeight,
                                    },
                                  ]}
                                />
                              </>
                            ) : (
                              <>
                                <Image
                                  source={{
                                    uri: currentUser?.photos[1],
                                  }}
                                  style={[
                                    styles.InterestCardImg,
                                    {
                                      height: interesetHeight,
                                    },
                                  ]}
                                />
                              </>
                            )}

                            {interest?.experience ? (
                              <>
                                {interest?.message ? (
                                  <>
                                    <View style={styles.InterestsMessage}>
                                      <Text
                                        style={[
                                          GlobalStyles.title2,
                                          {
                                            fontFamily: "InterBold",
                                            color: "#FDFBF9",
                                            marginBottom: 5,
                                          },
                                        ]}
                                      >
                                        {interests[0].experiences[0].title}
                                      </Text>

                                      <Text
                                        style={[
                                          GlobalStyles.bodyText,
                                          {
                                            color: "#FDFBF9",
                                          },
                                        ]}
                                      >
                                        {interests[0].message}
                                      </Text>
                                    </View>
                                  </>
                                ) : (
                                  <>
                                    <View style={styles.InterestsMessage}>
                                      <Text
                                        style={[
                                          GlobalStyles.title2,
                                          {
                                            fontFamily: "InterBold",
                                            color: "#FDFBF9",
                                            marginBottom: 5,
                                          },
                                        ]}
                                      >
                                        Liked your experience
                                      </Text>
                                    </View>
                                  </>
                                )}
                              </>
                            ) : (
                              <>
                                {interest?.message ? (
                                  <>
                                    <>
                                      <View style={styles.InterestsMessage}>
                                        <Text
                                          style={[
                                            GlobalStyles.title2,
                                            {
                                              fontFamily: "InterBold",
                                              color: "#FDFBF9",
                                              marginBottom: 5,
                                            },
                                          ]}
                                        >
                                          {interests[0].experiences[0].title}
                                        </Text>

                                        <Text
                                          style={[
                                            GlobalStyles.bodyText,
                                            {
                                              color: "#FDFBF9",
                                            },
                                          ]}
                                        >
                                          {interests[0].message}
                                        </Text>
                                      </View>
                                    </>
                                  </>
                                ) : (
                                  <>
                                    <>
                                      <View style={styles.InterestsMessage}>
                                        <Text
                                          style={[
                                            GlobalStyles.title2,
                                            {
                                              fontFamily: "InterBold",
                                              color: "#FDFBF9",
                                              marginBottom: 5,
                                            },
                                          ]}
                                        >
                                          Liked your Profile
                                        </Text>
                                      </View>
                                    </>
                                  </>
                                )}
                              </>
                            )}
                          </View>
                          <View style={styles.InterestsProfileInfoWrap}>
                            <View style={styles.InterestsProfileInfo}>
                              <View style={styles.InterestsProfileInfoName}>
                                <Image
                                  source={interests[0].image}
                                  style={styles.InterestCardImgIcon}
                                />
                                <Text
                                  style={[
                                    GlobalStyles.title1,
                                    {
                                      lineHeight: 22,
                                    },
                                  ]}
                                >
                                  {interest.user.firstName}
                                </Text>
                                <FeedIcons.VerifiedBadge />
                              </View>
                            </View>
                          </View>
                        </View>
                      </TouchableOpacity>
                    );
                  })}
                </View>
              </>
            )}
          </View>
        </ScrollView>
      </ImageBackground>
     </View>     
    </View>
  );
}

{/* <BlurView
        tint="dark"
        intensity={60}
        style={{
          position: "absolute",
          flex: 1,
          zIndex: 40,
          width: Dimensions.get("window").width,
          height: Dimensions.get("window").height,
          backgroundColor: "rgba(0,0,0,0.8)",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <FeedIcons.ComingSoon />
        <View
          style={{
            width: "80%",
          }}
        >
          <CustomComponent.AppBtn
            name="Explore Experiences"
            onPress={() => {
              navigation.navigate("Discover" as never);
            }}
            style={{
              marginTop: 20,
              // paddingHorizontal: 30,
              backgroundColor: "transparent",
              marginHorizontal: 30,
              paddingVertical: 15,
              borderColor: "white",
              borderWidth: 0.5,
              borderRadius: 40,
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              alignItems: "center",
            }}
            textStyle={{
              textAlign: "center",
              color: "white",
            }}
          />
        </View>
      </BlurView> */}